/**
 * A connector kit's watcher: Symphony's own proactive work for the owner, always on and on no routine
 * screen. The genome resumes one that is paused, so a switch for it would do nothing. The server's
 * `routines` action drops them already (`isKitWatcher` in ai-scheduling-assistant-server); this covers the
 * two older routine reads that do not go through it. Same rule as pulse's `PulseCharger.isUnbilled`.
 */
export function isKitWatcher(routine: { sourceConnectorSlug?: string | null; sourceTemplateSlug?: string | null }): boolean {
  return Boolean(routine.sourceConnectorSlug) && Boolean(routine.sourceTemplateSlug?.endsWith('-watcher'));
}
